import {gql} from '@apollo/client'

export const SYSTEM_ANNOUNCES = gql`
  query systemAnnounces($per: Int, $page: Int) {
    systemAnnounces(per: $per, page: $page) {
      totalCount
      list {
        id
        title
        link
        publishAt
        systemAnnounceType
      }
    }
  }
`

export interface SystemAnnouncesQueryVariables {
  per?: number
  page?: number
}

export interface SystemAnnouncesQueryResult {
  systemAnnounces: {
    totalCount: number
    list: SystemAnnounce[]
  }
}

export interface SystemAnnounce {
  id: string
  title: string
  publishAt: string
  systemAnnounceType: 'link' | 'body'
  link?: string
}
